import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

interface DatePickerWithTimeProps {
    label: string;
    value: Date | null;
    onChange: (date: Date | null) => void;
    disabled?: boolean;
    minDate?: Date;
    maxDate?: Date;
}

export const DatePickerWithTime: React.FC<DatePickerWithTimeProps> = ({ label, value, onChange, disabled, minDate, maxDate }) => {
    return (
        <div className="w-full">
            <label className="block text-sm font-medium mb-1">{label}</label>
            <DatePicker
                selected={value}
                onChange={onChange}
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={15}
                timeCaption="Время"
                dateFormat="yyyy-MM-dd HH:mm"
                className="w-full px-3 py-2 border rounded-md"
                disabled={disabled}
                minDate={minDate}
                maxDate={maxDate}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
             />
        </div>
    );
};
